var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31889_2901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.6865H7.875C8.11563 12.6865 8.3125 12.4896 8.3125 12.249V10.499H9.625V12.249C9.625 13.2143 8.84023 13.999 7.875 13.999H1.75C0.784766 13.999 0 13.2143 0 12.249V6.12402C0 5.15879 0.784766 4.37402 1.75 4.37402H3.5V5.68652H1.75C1.50937 5.68652 1.3125 5.8834 1.3125 6.12402V12.249C1.3125 12.4896 1.50937 12.6865 1.75 12.6865ZM6.125 8.31152H12.25C12.4906 8.31152 12.6875 8.11465 12.6875 7.87402V1.74902C12.6875 1.5084 12.4906 1.31152 12.25 1.31152H6.125C5.88438 1.31152 5.6875 1.5084 5.6875 1.74902V7.87402C5.6875 8.11465 5.88438 8.31152 6.125 8.31152ZM4.375 7.87402V1.74902C4.375 0.783789 5.15977 -0.000976562 6.125 -0.000976562H12.25C13.2152 -0.000976562 14 0.783789 14 1.74902V7.87402C14 8.83926 13.2152 9.62402 12.25 9.62402H6.125C5.15977 9.62402 4.375 8.83926 4.375 7.87402Z",
    fill: "#002E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31889_2901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/Clone.f477c687de450549aeb73eab83c30978.svg";
export { ForwardRef as ReactComponent };